export default __webpack_public_path__ + "static/media/caution-icon.1c32ff34.svg";